import { useWindowSize } from "@/hooks/use-window-size";
import { useOrderResumeStore } from "@/stores";
import { Badge, Button, Icon, IconButton } from "@stone-payments/jade";

type NavigationCartButtonProps = {
  analiticaEvent?: () => void;
};

export const NavigationCartButton = ({
  analiticaEvent,
}: NavigationCartButtonProps) => {
  const { toggleDrawer, summary } = useOrderResumeStore();
  const { aboveLargeScreen } = useWindowSize(767);

  const handleToggleDrawer = () => {
    analiticaEvent?.();
    toggleDrawer();
  };

  return aboveLargeScreen ? (
    <div
      className="flex items-center justify-between"
      key="cart"
      aria-label="Carrinho"
      data-testid="navigation-cart-button"
    >
      <Button
        variant="on-brand-solid"
        size="large"
        className="flex"
        onClick={handleToggleDrawer}
      >
        <span className="relative flex h-[28px] items-center justify-between gap-jade-100">
          <span className="relative flex items-center">
            <Icon use="cart" size="medium" color="brand" />
            <span className="absolute -top-4 left-2">
              <Badge label={summary.itemsCount} variant="text" voice="brand" />
            </span>
          </span>
          Carrinho
        </span>
      </Button>
    </div>
  ) : (
    <div className="relative" data-testid="navigation-cart-button">
      <IconButton
        icon="cart"
        size="medium"
        variant="on-brand-solid"
        onClick={handleToggleDrawer}
      />
      <button
        className="absolute -top-1 right-0 cursor-pointer"
        onClick={handleToggleDrawer}
      >
        <Badge label={summary.itemsCount} variant="text" voice="brand" />
      </button>
    </div>
  );
};
